import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaHoldingsMenuRegistry = {
    personalize_nebulaHoldings: {
        label: "Nebula Holdings",
        link: PAGE_URL.NEBULA_HOLDINGS_PAGE,
        key: PAGE_URL.NEBULA_HOLDINGS_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaHoldingsMenuRegistry;
